import { Flex, Tag } from '@lokalise/louis';

import { useTheme } from '@app/styled';

import { Badge } from './styles';

interface NavItemContentProps {
    label: string;
    badge?: number;
    novel?: boolean;
}

const NavItemContents = ({ label, badge, novel }: NavItemContentProps) => {
    const theme = useTheme();

    return (
        <Flex gap={1}>
            <div>
                <span>{label}</span>
                {!!badge && (
                    <Badge role="status" aria-label={`${badge} items requiring attention`}>
                        {badge > 9 ? '9+' : badge}
                    </Badge>
                )}
            </div>
            {novel && <Tag color={theme.colors.primary['400']}>New</Tag>}
        </Flex>
    );
};

export default NavItemContents;
